module.exports = {"notification.message":"Wix.com verwendet Cookies, um Ihnen das bestmögliche Erlebnis zu gewährleisten.","notification.got.it":"Okay","notification.more.info":"Weiterlesen","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_de.json
// module id = 45
// module chunks = 0